import { ClipboardCopyButton } from '#/components/buttons/ClipboardCopyButton';
import { ZazumeRoute } from '#/containers/router/routes/types';
import { Flex, getIcon, IconType, Semibold, ZZMColor } from '@zazume/zzm-base';
import React, { FC, ReactNode } from 'react';
import { Link } from './atoms/Link';

interface TextProps {
  value?: string | null | ReactNode;
  emptyValue?: string;
  icon?: IconType;
  color?: ZZMColor;
  withCopy?: boolean;
  to?: ZazumeRoute;
  openInNewTab?: boolean;
}

export const Text: FC<TextProps> = ({ icon, value, emptyValue, color, withCopy, to, openInNewTab }) => {
  const Icon = icon && getIcon(icon);
  return <Flex gap="xs">
    {Icon && value && <Icon size={20} color="Gray400"/>}
    <Semibold variant="S" color={color}>{value || emptyValue}</Semibold>
    {withCopy && value && typeof value === 'string' && <ClipboardCopyButton value={value}/>}
    {to && <Link to={to} openInNewTab={openInNewTab}/>}
  </Flex>;
};
